import React, { Component, Fragment } from 'react'
import Cookies from 'js-cookie'
import PropTypes from 'prop-types'

import Link from '../typography/Link'
import Modal from '../../Modal'
import Input from '../Input'
import Heading4 from '../typography/Heading4'
import Button from '../Button/Button'
import RDGateway from '../../../gateways/RDGateway'
import ModalTestimonials from '../TestimonialCard/ModalTestimonials'

const FIELDS = ['name', 'email', 'telephone', 'activity', 'users']

const ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
}

const USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
}

class DemoRequestLink extends Component {
    static propTypes = {
        b2b: PropTypes.bool,
        className: PropTypes.string,
        color: PropTypes.string,
        contaAzul: PropTypes.bool,
        partnerId: PropTypes.string,
    }

    static defaultProps = {
        b2b: false,
        contaAzul: false
    }

    constructor(props) {
        super(props)

        this.rdGateway = new RDGateway()
        this.state = this.getInitialState(props)

        globalThis.optimizeOpenPopup = () => {
            this.setState({ showDemoModal: true });
        }
    }

    getInitialState(props) {
        const initialObject = {
            showDemoModal: false,
            company: '',
            name: '',
            email: '',
            telephone: '',
            activity: '',
            users: '',
            typingTimeout: 0,
            partnerId: props.partnerId,
        }
        FIELDS.forEach(campo => {
            initialObject[`${campo}Error`] = false
            initialObject[`${campo}Typing`] = false
        })
        return initialObject
    }

    setDataByCookie() {
        this.setState({
            partnerId: Cookies.get('leaderPartnerId') || this.state.partnerId || ''
        })
    }

    openDemoModal(e) {
        e.preventDefault()

        this.setState({
            showDemoModal: true,
        })
    }

    closeDemoModal() {
        this.setState({
            showDemoModal: false,
        })
    }

    handleChange(e) {
        const name = e.target.id
        let value = e.target.value
        let company = this.state.name + ' - ' + this.state.email

        if (name === 'telephone') {
            value = this.telephoneMask(value)
        } else if (name === 'name') {
            company = value + ' - ' + this.state.email
        } else if (name === 'email') {
            company = this.state.name + ' - ' + value
        }

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        this.setState({
            [name]: value,
            company,
            [`${name}Error`]: false,
            [`${name}Typing`]: true,
            typingTimeout: setTimeout(() => {
                if (name === 'email' && this.validateEmail(this.state.email)) {
                }
            }, 3000)
        })
    }

    handlerEnterpriseActivity(tipo) {
        this.setState({ 'activity': tipo })
    }

    getSelectedActivity(selected) {
        return this.state.activity === selected ? 'active' : ''
    }

    handlerUsers(tipo) {
        this.setState({ 'users': tipo })
    }

    getSelectedUsers(selected) {
        return this.state.users === selected ? 'active' : ''
    }

    validation() {
        const newState = {}

        const regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/
        FIELDS.forEach(campo => {
            newState[`${campo}Error`] = !this.state[campo]
            switch (campo) {
                case 'email': {
                    newState[`${campo}Error`] = !this.validateEmail(this.state[campo])
                    break
                }
                case 'telephone': {
                    newState[`${campo}Error`] = !regexTelephone.test(this.state[campo])
                    break
                }
            }
        })
        this.setState(newState)
        const lista = Object.values(newState)
        return lista.every(value => (!value))
    }

    validateEmail(email) {
        const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regexEmail.test(email.toLowerCase())
    }

    telephoneMask(value) {
        let cleanTelephone = value ? value.replace(/\D/g, '') : ''
        const numberLength = cleanTelephone.length

        if (numberLength > 10) {
            cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7)
        } else if (numberLength > 6 && numberLength < 11) {
            cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6)
        }

        if (numberLength > 2) {
            cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2)
        }

        if (numberLength > 0) {
            cleanTelephone = '(' + cleanTelephone.slice(0)
        }

        return cleanTelephone
    }

    submitForm(e) {
        e.preventDefault()
        if (this.validation()) {
            const data = {
                conversion_identifier: this.props.contaAzul ? 'fale-consultor-b2b-conta-azul': this.props.idtConsultor ?  'fale-consultor-b2b' : 'solicite-uma-demonstracao-do-meus-pedidos',
                'cf_tipo_de_conversao': this.props.b2b ? 'Solicitou demonstração E-commerce B2B' : this.props.contaAzul ? 'Solicitou demonstração E-commerce B2B - ContaAzul' : 'Solicitou demonstração',
                company_name: this.state.company,
                name: this.state.name,
                email: this.state.email,
                personal_phone: this.state.telephone,
  
                'cf_atividade_da_empresa': this.state.activity,
                'cf_numero_de_vendedores': this.state.users,
                event_action: 'solicitou_demo',
                event_label:  this.props.b2b ? 'ecommerce_b2b' : this.props.idtConsultor ?  'ecommerce_b2b' : 'forca_de_vendas',
            }

            if (this.state.partnerId) {
                data.conversion_identifier = 'canais-lp'
                data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId
            }


            let redirectLink = 'https://mercos.com/tp/solicitou-demo-fv/'
            if (this.state.activity === ACTIVITY.outra) redirectLink = 'https://materiais.mercos.com/tp-smb-solicitou-demo'
            else if (this.state.activity === ACTIVITY.rep) redirectLink = 'https://materiais.mercos.com/tp-reps-solicitou-demo'
            

            this.rdGateway.sendToRDStation(data, redirectLink)

        }
    }


    checkTeam() {
        let team = ''
        const activity = this.state.activity || ''
        const users = this.state.users || ''
        const isB2b = this.props.b2b || ''
        const isContaAzul = this.props.contaAzul

        if (isContaAzul) {
            team = 'Canais'
        } else if (isB2b) {
            team = 'B2B'
        } else if (activity === 'Indústria' || activity === 'Distribuição' || activity === 'Outro') {
            if (users === '1' || users === '2-5' || users === '6-20') {
                team = 'Tigers'
            } else if (users === '21-50' || users === '51 ou mais') {
                team = 'Eagles'
            }
        } else if (activity === 'Representação Comercial') {
            team = 'Wolves'
        } else {
            team = 'Indefinido'
        }

        return team;
    }

    componentDidMount() {
        this.setDataByCookie()
    }

    getDemoModal() {
        return (
            <Modal callbackCloseModal={() => this.closeDemoModal()} className="site-simple-modal-testimonials">
                <div className="modal-header-logo">
                    <div className="logo-mercos-new-home"></div>
                </div>
                <div className='container-form-modal'>
                    <Heading4>{this.props.b2b  ? 'Solicitar contato' : 'Solicite uma demonstração'}</Heading4>
                    {this.getForm()}
                </div>
                <ModalTestimonials />
            </Modal>
        )
    }

    getForm() {
        return (
            <form action='.' method='POST' className='form-rounded-inputs' onSubmit={e => this.submitForm(e)}>
                <input type='hidden' name='company' value={this.state.company} />

                <label htmlFor='name'>Nome</label>
                <Input id='name' value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} autoFocus />

                <label htmlFor='email'>E-mail</label>
                <Input id='email' value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} />

                <label htmlFor='telephone'>Telefone</label>
                <Input id='telephone' value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength='15' />

                <label>Qual é a atividade da sua empresa?</label>
                <div className={'group-buttons'}>
                    <Button model='outline' className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.industria)}>Indústria</Button>
                    <Button model='outline' className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.distribuicao)}>Distribuição</Button>
                    <Button model='outline' className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.rep)}>Representante comercial</Button>
                    <Button model='outline' className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.outra)}>Outra</Button>
                    {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                </div>

                <label>Qual é o número de vendedores da sua empresa?</label>
                <div className={'group-buttons'}>
                    <Button model='outline' className={this.getSelectedUsers(USERS.um)} onClick={() => this.handlerUsers(USERS.um)}>1</Button>
                    <Button model='outline' className={this.getSelectedUsers(USERS.cinco)} onClick={() => this.handlerUsers(USERS.cinco)}>2-5</Button>
                    <Button model='outline' className={this.getSelectedUsers(USERS.vinte)} onClick={() => this.handlerUsers(USERS.vinte)}>6-20</Button>
                    <Button model='outline' className={this.getSelectedUsers(USERS.cinquenta)} onClick={() => this.handlerUsers(USERS.cinquenta)}>21-50</Button>
                    <Button model='outline' className={this.getSelectedUsers(USERS.cinquentaum)} onClick={() => this.handlerUsers(USERS.cinquentaum)}>51 ou mais</Button>
                    {this.state.usersError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                </div>

                <div className='submit-demo-modal'>
                    <Button type='submit' radius={this.props.contaAzul ? 'all-rounded' : 'half-rounded'} className={this.props.contaAzul && 'conta-azul'}>{this.props.children || 'SOLICITAR'}</Button>
                </div>
            </form>
        )
    }

    render() {
        return (
            <Fragment>
                {this.props.openForm ? this.getForm() : ''}

                {this.props.openForm ? '' :
                    <Fragment>
                        <Link
                            href='.'
                            color={this.props.color}
                            className={this.props.className}
                            onClick={e => this.openDemoModal(e)}
                            title='Peça uma demonstração aos nossos especialistas.'
                        >
                            {this.props.b2b ? <Fragment>E-commerce B2B <br />opcional, com preço sob consulta.</Fragment> : <span style={{ whiteSpace: 'nowrap' }}>peça uma demonstração</span>}
                        </Link>
                        {this.state.showDemoModal && this.getDemoModal()}
                    </Fragment> }


            </Fragment>
        )
    }
}

export default DemoRequestLink



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/DemoRequest/DemoRequestLink.jsx